<template>
  <vx-card class="p-2">

    <div class="flex justify-center flex-wrap mb-5">
      <vx-tooltip :text="$t('general.download') + ' ' + $t('general.excel-template')">
        <vs-button @click="onDownloadTemplateClick" color="primary" icon="icon-download"
                   icon-pack="feather"
                   radius size="large"
                   type="gradient">
        </vs-button>
      </vx-tooltip>
    </div>

    <div class="text-center">
      <h4>{{ $t('general.download') }}</h4>
      <p class="text-grey">{{ $t('general.excel-template') }}</p>
    </div>

  </vx-card>
</template>

<script>
  export default {
    props: {
      templateUrl: String
    },
    name: "CardDownloadTemplate",
    methods: {
      onDownloadTemplateClick() {
        if (this.templateUrl) {
          window.open(this.templateUrl, '_blank');
        }
      }
    }

  }
</script>

<style scoped>

</style>
